import { createSlotRecipe } from './runtime';

const menuConfig = {"name":"menu","slots":["root","trigger","panel","item","itemIcon","separator","heading"],"defaultVariants":{"align":"end"},"variantMap":{"align":["end","start"]}}

export const menu = /* @__PURE__ */ createSlotRecipe(menuConfig)